import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import bookreviewStyle from './ParentsBookReview.module.css'
import ParentsHeader from '../../components/Header/ParentsHeader'
import BackBar from '../../components/BackBar/BackBar'
import SideBar from '../../components/Sidebar/SideBar'
import Authorimage from '../../../assets/images/9780823454143.jpg'
import { useMediaQuery } from 'react-responsive';
import { useCart } from '../../../context/CartContext';
require('typeface-poppins')

export default function ParentsBookReview() {

  const location = useLocation();
  const { book, authorName } = location.state || {};
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [isAdded, setIsAdded] = useState(false);
  const { cart, addToCart, removeFromCart } = useCart();


  const [quantity, setQuantity] = useState(1);

  const increaseQuantity = () => setQuantity(q => q + 1);
  const decreaseQuantity = () => setQuantity(q => Math.max(1, q - 1));

  useEffect(() => {
    const alreadyExists = cart.some(item => item.book_id === book?.book_id);
    setIsAdded(alreadyExists);
  }, [cart, book]);

  const handleAddToCart = () => {
    const bookWithDetails = { ...book, authorName, quantity };

    const alreadyExists = cart.some(item => item.book_id === book.book_id);

    if (!alreadyExists) {
      addToCart(bookWithDetails);
      setIsAdded(true);
    } else {
      removeFromCart(book.book_id);
      setIsAdded(false);
    }
  };


  return (
    <>
      <ParentsHeader />
      <div className={bookreviewStyle.parentsbookreviewPage}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            {isMobile ? (
              undefined
            ) : (
              <div className='col' style={{ maxWidth: '275px' }}>
                <SideBar />
              </div>
            )}
            <div className="col">
              {isMobile ? (
                // Mobile Parent Book Review
                <div className={`${bookreviewStyle.mobilbookreviewWrap} mb-4`}>
                  <h2>Books by Elliot Finch</h2>
                  <div className={`${bookreviewStyle.mobilreviewBlock}`}>
                    <div className='row g-0 mb-4'>
                      <div className='col-5'>
                        <div className={`${bookreviewStyle.mobilreviewimgBlock} pe-3`}>
                          <img src={Authorimage} width="600" height="840" />
                        </div>
                      </div>
                      <div className='col-7'>
                        <div className={`${bookreviewStyle.mobilreviewtextBlock} h-100 d-flex justify-content-between flex-column`}>
                          <div className={bookreviewStyle.mobilreviewcontentBox}>
                            <h4>Brown Bear, Brown Bear What Do You See? </h4>
                          </div>
                          <div className={bookreviewStyle.mobilreviewpiceBox}>
                            <p>Price</p>
                            <span>$17.99</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>
                        <div className={`${bookreviewStyle.mobilreviewQty} mb-4`}>
                          <select className={`${bookreviewStyle.mobilbookreviewSelect} form-select`}>
                            <option>Qty</option>
                            <option>1</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>
                        <div className={`${bookreviewStyle.mobilreviewBtn} mb-4`}>
                          <button className={`${bookreviewStyle.mobilbookreviewButton} btn btn-success`}>Add to Cart</button>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-12'>
                        <div className={bookreviewStyle.mobilreviewDescription}>
                          <h5> Description </h5>
                          <p> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
                            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
                            sanctus est Lorem.
                          </p>
                          <h5> Type </h5>
                          <p> Hard Cover </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Desktop Parent Book Review
                <div className={`${bookreviewStyle.bookreviewWrapper} mb-4 d-flex justify-content-start align-items-start`}>
                  <div className='me-5 mb-3'>
                    <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/ProductImages/${book?.book_id}.jpg`} width="228" height="342" />
                  </div>
                  <div className={bookreviewStyle.bookreviewContent}>
                    <h2>{book?.title}</h2>
                    <p>By {authorName}</p>
                    <h3>Description:</h3>
                    <p> Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
                      invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
                      et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem.
                    </p>
                    <h5><b>Type:</b> {book?.format} </h5>
                    <h6 className='mb-2'><b>Price:</b> ${book?.price} </h6>
                    <div className={`${bookreviewStyle.bookreviewbuttons} d-flex flex-wrap align-items-center`}>


                      <div className='d-flex me-3'>
                        <button className='btn btn-primary' onClick={decreaseQuantity}>-</button>
                        <input type="number" className='form-control' value={quantity} readOnly style={{ width: '50px', textAlign: 'center' }} />
                        <button className='btn btn-primary' onClick={increaseQuantity}>+</button>
                      </div>

                      {/* <button className={`${bookreviewStyle.bookreviewaddButton} btn btn-success`}>Add to Cart</button> */}
                      <button className={`${bookreviewStyle.bookreviewaddButton} btn ${isAdded ? 'btn-danger' : 'btn-success'}`} onClick={handleAddToCart} >
                        {isAdded ? 'Added' : 'Add to Cart'}
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
